// extracted by mini-css-extract-plugin
export default {"snackbarsContainer":"SnackbarsContainer_snackbarsContainer__APesI"};